module.exports = __webpack_public_path__ + "static/zoom-in.41f102a21a2fad7cc8ec50e8674bb496.svg";